import HigoSuite from './HigoSuiteContainer';
export default HigoSuite;
